import axios from 'axios';
import { GAMEZOP, GAMEPIX } from '../utils/constants';

const GAMEZOP_URL = GAMEZOP.API_URL || 'https://pub.gamezop.com/v3/games';
const GAMEZOP_ID  = GAMEZOP.ID_PRIMARY || '9632';
const GAMEPIX_URL = GAMEPIX.API_URL || 'https://feeds.gamepix.com/v2/json';
const GAMEPIX_SID = GAMEPIX.SID || 'G2A5E';

export const fetchGamezopGames = async (id = GAMEZOP_ID) => {
  const res = await axios.get(`${GAMEZOP_URL}?id=${id}&lang=en`);
  return res?.data?.games || [];
};

export const fetchGamePixGames = async (pagination = 12, page = 1) => {
  const res = await axios.get(
    `${GAMEPIX_URL}?sid=${GAMEPIX_SID}&order=pubdate&pagination=${pagination}&page=${page}`
  );
  return res?.data?.items || [];
};
